import script from "./UiLoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiLoadingSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./UiLoadingSpinner.vue?vue&type=style&index=0&id=278d92c6&lang=sass&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278d92c6"]])

export default __exports__